import React from 'react';
import fetch from './fetch';
import {Alert, Button, Col, Container, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table} from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Sextant} from './Sextant';
import {Brush, CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import Toothchart from "./Toothchart";
import {getColourFromScore} from "./util";
import auth from './auth';
import brushlinkIcon from './brushlink_icon.svg';
import sonicareIcon from './sonicare_icon.png';
import moment from 'moment';
import TooltipSB from "./Tooltip";


//window.$ = window.jQuery = require('../node_modules/jquery/dist/jquery.min');

class Scorecard extends React.Component {
    static CURRENT_PERIO = "Current"
    static sextantPlans = [
        "top_right_time",
        "top_center_time",
        "top_left_time",
        "bottom_left_time",
        "bottom_center_time",
        "bottom_right_time",
    ];
    static sextants = [
        1, 1, 1, 1, 1,
        2, 2, 2, 2, 2, 2,
        3, 3, 3, 3, 3,
        4, 4, 4, 4, 4,
        5, 5, 5, 5, 5, 5,
        6, 6, 6, 6, 6,
    ];
    static UP_TREND = '↗';
    static DOWN_TREND = '↘';
    static HORIZONTAL_TREND = '→';
    static MAX_PERIO_SCORE = 9;
    static MAX_SECONDARY_PERIO_SCORE = 4;

    constructor(props) {
        super(props);

        this.state = {
            pairings: null,
            graphBrushData: [],
            sextantScores: [],
            generalScore: null,
            brushScorePastLabel: "",
            brushScoreLabel: "",

            perioExams: [],
            brushingData: null,
            activePerio: null,
            activePreviousPerio: null,
            currentSextant: null,
            perioScore: {
                score: -1,
                teeth: null
            },
            previousPerioScore: {
                score: -1,
                teeth: null
            },

            perioDate: null,
            previousPerioDate: null,

            manufacturer: null,
            manufacturer_id: null,

            teeth: {},
            sextants: {
                1: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''},
                2: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''},
                3: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''},
                4: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''},
                5: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''},
                6: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''}
            },

            plan: null,

            weights: {
                pd_weight: 10,
                gm_weight: 10,
                cal_weight: 10,
                mgj_weight: 10,
                fg_weight: 10,
                bld_weight: 10,
                sup_weight: 10,
                mob_weight: 10,
                pla_weight: 10,
                bl_weight: 10,
                br_score_weight: 33,
                br_freq_weight: 33,
                br_length_weight: 33
            },
            generalGraphData: [],
            sextantGraphData: [[], [], [], [], [], []],
            visible: false,
            printMode: false,
            practice_name: '',
            patient: null,
            brush_modal: false,
        };

        this.perioScoreCache = {};
    }

    static onPrintClick(e) {
        window.print();
    }

    componentDidMount() {
        let activePerioDate = undefined;
        let identifiers = this.getPatientIdentifiers();

        this.updateAverageScore()


        fetch('/api/v1/brush-status', {
            method: 'GET',
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                let body = await resp.json();
                if (body) {
                    this.setState({
                        pairings: body
                    });

                    if (body.brushlink === false) {
                        this.setState({
                            brush_modal: true,
                        });
                    }

                }
            })
            .catch((err) => {
                console.error('Could not get brush pairing status', err);
            });

        fetch('/api/v1/provider-info', {
            method: 'GET',
        })
            .then(async (resp) => {
                if (resp && !resp.ok) {
                    throw "invalid response status";
                }
                let body = await resp.json();
                if (body) {
                    this.setState({
                        chart_notation: body.ddx_tooth_notation,
                        practice_name: body.hasOwnProperty('ddx_parent_name') ? body.ddx_parent_name : '',
                    });
                }
            })
            .catch((err) => {
                console.error('Could not get DDX user info', err);
            });

        fetch('/api/v1/preferences', {
            method: 'GET',
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                let body = await resp.json();
                this.setState({
                    weights: body
                });
            })
            .catch((err) => {
                console.error('Could not fetch preferences', err);
            });

        fetch(`/api/v1/patient-info?chart_number=${encodeURIComponent(identifiers.chart)}&pm_id=${encodeURIComponent(identifiers.pm_id)}&id=${encodeURIComponent(identifiers.id)}`, {
            method: 'GET',
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                let body = await resp.json();
                this.setState({
                    patient: body
                });
            })
            .catch((err) => {
                console.error('Could not get patient information', err);
            });

        if (identifiers.chart !== "" || identifiers.pm_id !== "") {
            fetch(`http://127.0.0.1:54280/pms/dentrix/perio_exams?chart_number=${encodeURIComponent(identifiers.chart)}&pm_id=${encodeURIComponent(identifiers.pm_id)}`, {
                credentials: 'omit'
            })
                .then(async (resp) => {
                    if (!resp || !resp.ok) {
                        throw "invalid response status";
                    }
                    let json = await resp.json();

                    json.unshift({
                        date: Scorecard.CURRENT_PERIO
                    });
                    if (json.length > 0) {
                        activePerioDate = json[0].date;
                    }
                    this.setState({
                        perioExams: json,
                        activePerioDate
                    });
                })
                .catch((err) => {
                    console.error('Could not fetch perio information. No perio available.', err);
                    let today = new Date();
                    this.setState({
                        activePerioDate: today.getFullYear() + "-" + (("0" + (today.getMonth() + 1)).slice(-2)) + "-" + (("0" + today.getDate()).slice(-2))
                    });
                });
        } else {
            let today = new Date();
            this.setState({
                activePerioDate: today.getFullYear() + "-" + (("0" + (today.getMonth() + 1)).slice(-2)) + "-" + (("0" + today.getDate()).slice(-2))
            });
        }
        this.getBrushingPlan();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.activePerioDate !== prevState.activePerioDate && this.state.activePerioDate) {
            let identifiers = this.getPatientIdentifiers();

            let index = -1;

            let d = this.state.activePerioDate;
            if (d === Scorecard.CURRENT_PERIO && this.state.perioExams.length >= 2) {
                d = this.state.perioExams[1].date;
            }

            let dPreviousIndex = -1;

            for (let i = 0; i < this.state.perioExams.length; i++) {
                if (this.state.perioExams[i].date === d) {
                    dPreviousIndex = i + 1;
                    break;
                }
            }


            if (d && d !== Scorecard.CURRENT_PERIO) {
                if (identifiers.chart !== "" || identifiers.pm_id !== "") {
                    fetch(`http://127.0.0.1:54280/pms/dentrix/perio_exam?chart_number=${encodeURIComponent(identifiers.chart)}&pm_id=${encodeURIComponent(identifiers.pm_id)}&date=${encodeURIComponent(d)}`, {
                        credentials: 'omit'
                    })
                        .then(async (resp) => {
                            if (resp && resp.ok) {
                                let json = await resp.json();
                                this.setState({
                                    activePerio: json
                                });

                                for (let i = 0; i < this.state.perioExams.length; i++) {
                                    if (this.state.activePerioDate === this.state.perioExams[i].date) {
                                        if (i + 1 < this.state.perioExams.length) {
                                            index = i + 1;
                                            break;
                                        }
                                    }
                                }

                                let perioDate = this.state.activePerioDate;
                                if (this.state.activePerioDate === Scorecard.CURRENT_PERIO) {
                                    let today = new Date();
                                    perioDate = today.getFullYear() + "-" + (("0" + (today.getMonth() + 1)).slice(-2)) + "-" + (("0" + today.getDate()).slice(-2));
                                }

                                let previousPerioDate = null;
                                previousPerioDate = index === -1 ? null : this.state.perioExams[index].date

                                this.setState({
                                    perioDate: perioDate,
                                    previousPerioDate: previousPerioDate
                                });
                                this.updateBrushingData(previousPerioDate, perioDate);
                            } else {
                                throw "invalid response status";
                            }
                        })
                        .catch((err) => {
                            console.error('Could not fetch perio exams. No perio available.', err);
                        });

                    if (dPreviousIndex >= 1 && dPreviousIndex < this.state.perioExams.length) {
                        fetch(`http://127.0.0.1:54280/pms/dentrix/perio_exam?chart_number=${encodeURIComponent(identifiers.chart)}&pm_id=${encodeURIComponent(identifiers.pm_id)}&date=${encodeURIComponent(this.state.perioExams[dPreviousIndex].date)}`, {
                            credentials: 'omit'
                        })
                            .then(async (resp) => {
                                if (resp && resp.ok) {
                                    let json = await resp.json();
                                    this.setState({
                                        activePreviousPerio: json
                                    });
                                } else {
                                    throw "invalid perio response status";
                                }
                            })
                            .catch((err) => {
                                console.error('Could not fetch previous perio exams. No perio available.', err);
                                this.setState({
                                    activePreviousPerio: null,
                                });
                            });
                    } else {
                        this.setState({
                            activePreviousPerio: null,
                        });
                    }
                }
            }
        }

        if (this.state.activePerio !== prevState.activePerio || this.state.currentSextant !== prevState.currentSextant || this.state.currentTooth !== prevState.currentTooth) {
            this.setState({
                perioScore: {
                    score: -1,
                    teeth: null
                }
            });

            this.calculatePerioScore(this.state.activePerio).then((res) => {
                this.setState({
                    perioScore: res
                });
            });
        }

        if (this.state.perioScore !== prevState.perioScore && this.state.perioScore) {
            this.colourTeeth();
        }

        if (this.state.activePreviousPerio !== prevState.activePreviousPerio && this.state.activePreviousPerio) {
            this.setState({
                previousPerioScore: {
                    score: -1,
                    teeth: null
                }
            });

            this.calculatePerioScore(this.state.activePreviousPerio).then((res) => {
                this.setState({
                    previousPerioScore: res
                });
                this.calculateBrushingScores();
            });
        }
    }

    colourTeeth() {
        let teethState = {};

        for (let toothNo = 1; toothNo <= 32; toothNo++) {
            let color;
            let perioScores = this.state.perioScore;
            if (this.state.activePerio && this.state.activePerio.hasOwnProperty('Teeth')) {
                let t;
                for (let tooth of this.state.activePerio.Teeth) {
                    if (tooth.ToothNum === toothNo) {
                        t = tooth;
                    }
                }
                if (perioScores.teeth) {
                    color = getColourFromScore(perioScores.teeth[t.ToothNum - 1], 100, 1);
                }
            }
            if (!color) color = '#ffffff';


            let toothInSextant = typeof this.state.currentSextant === 'number' &&
                this.state.currentSextant === Scorecard.sextants[toothNo - 1];

            let strokeWidth = 10;
            if (this.state.currentTooth === toothNo) {
                strokeWidth = 25;
            } else if (toothInSextant) {
                strokeWidth = 15;
            }

            teethState[toothNo] = {
                fill: color,
                //hidden: tooth.ToothState === 1,
                //stroke: toothInSextant ? '#0F0' : '#000',
                opacity: toothInSextant || this.state.currentSextant === null ? '1' : '0.1',
                strokeWidth
            };
        }

        this.setState({teeth: teethState});
    }

    getPatientIdentifiers() {
        let chart = this.props.params.hasOwnProperty('patid') ? this.props.params.patid : '';
        if (!chart) {
            chart = this.props.location.query.chart_number;
        }
        let pm_id = this.props.location.query.pm_id;
        let id = this.props.location.query.id;
        return {
            chart: chart !== "undefined" && chart ? chart : "",
            pm_id: pm_id !== "undefined" && pm_id ? pm_id : "",
            id: id !== "undefined" && id ? id : ""
        };
    }

    getBrushingPlan() {
        let identifiers = this.getPatientIdentifiers();
        fetch(`/api/v1/brushing-plan?chart_number=${encodeURIComponent(identifiers.chart)}&pm_id=${encodeURIComponent(identifiers.pm_id)}&id=${encodeURIComponent(identifiers.id)}`, {
            method: 'GET',
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                let body = await resp.json();

                this.setState({
                    plan: body
                });
            })
            .catch((err) => {
                console.error('Could not fetch brushing plan', err);
            });
    }

    updateBrushingData(previousPerioDate, perioDate) {
        // brushing data
        let identifiers = this.getPatientIdentifiers();
        if (!identifiers.chart && !identifiers.id && !identifiers.pm_id) {
            return;
        }

        fetch(`/api/v1/scorecard-data?chart_number=${encodeURIComponent(identifiers.chart)}&pm_id=${encodeURIComponent(identifiers.pm_id)}&id=${encodeURIComponent(identifiers.id)}&from=${encodeURIComponent(previousPerioDate)}&to=${encodeURIComponent(perioDate)}`, {
            method: 'GET',
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    this.setState({
                        brushingData: null,
                    });
                    this.calculateBrushingScores();
                    throw "invalid response status";
                }
                let body = await resp.json();
                // console.log(body);

                if (body.hasOwnProperty('sessions_manufacturer') && body.hasOwnProperty('sessions_manufacturer_text')) {
                    this.setState({
                        manufacturer: body.sessions_manufacturer_text,
                        manufacturer_id: body.sessions_manufacturer,
                    });
                }

                if (!body.hasOwnProperty('sessions_brushing_sessions') || !body.sessions_brushing_sessions) {
                    this.setState({
                        brushingData: null,
                    });
                    this.calculateBrushingScores();
                    return;
                }
                body.sessions_brushing_sessions.sort(function (a, b) {
                    return (new Date(a.session_date)) - (new Date(b.session_date));
                });
                this.setState({
                    brushingData: body
                });
                this.calculateBrushingScores();
            })
            .catch((err) => {
                this.setState({
                    brushingData: null
                });

                this.setState({
                    sextants: {
                        1: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''},
                        2: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''},
                        3: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''},
                        4: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''},
                        5: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''},
                        6: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''}
                    }
                });
                console.error('Could not fetch brushing information', err);
            });
    }

    getTrendStats(prevScore, currentScore) {
        if (prevScore === -1 || currentScore === -1) {
            return null;
        }
        let label = Scorecard.DOWN_TREND;
        let color = '#FF0000';

        if (Math.round(currentScore) === Math.round(prevScore)) {
            label = Scorecard.HORIZONTAL_TREND;
            color = '#000000';
        } else if (currentScore < prevScore) {
            label = Scorecard.DOWN_TREND;
            color = '#FF0000';
        } else {
            label = Scorecard.UP_TREND;
            color = '#00FF00';
        }

        return {
            label: label,
            color: color
        };
    }

    getSextantScoreLabel(score) {
        if (score !== null && score !== "" && typeof score == "number") {
            return score.toString() + "%";
        }
        return "";
    }

    calculateBrushingScores() {
        if (!this.state.brushingData || !this.state.brushingData.hasOwnProperty('sessions_brushing_sessions') || this.state.brushingData.count <= 0) {
            let graphData = this.calculateGraphData();
            this.setState({
                generalGraphData: graphData.generalGraphData,
                sextantGraphData: graphData.sextantGraphData
            });
            this.setState({
                sextants: {
                    1: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''},
                    2: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''},
                    3: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''},
                    4: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''},
                    5: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''},
                    6: {hidden: false, label: "", trend: "", trendColor: "#000", brushTime: ''}
                }
            });
            return;
        }
        // console.log(this.state.brushingData);
        let sessions = this.state.brushingData.sessions_brushing_sessions;
        let earlySessions = sessions.slice(0, Math.ceil(sessions.length * 0.5));

        let earlyScores = this.calculateBrushScores(earlySessions);
        let brushingScores = this.calculateBrushScores(sessions);

        let graphData = this.calculateGraphData(sessions);

        this.setState({
            generalGraphData: graphData.generalGraphData,
            sextantGraphData: graphData.sextantGraphData,
            sextantScores: brushingScores.sextantScores,
            generalScore: brushingScores.generalScore,
            generalTrend: this.getTrendStats(earlyScores.generalScore, brushingScores.generalScore),
            averageBrushTime: brushingScores.averageBrushTime,
            averageBrushingDaily: brushingScores.averageBrushingDaily,
            daysMissed: this.state.brushingData.sessions_missed_days
        });

        let trendData0 = this.getTrendStats(earlyScores.sextantScores[0], brushingScores.sextantScores[0]);
        let trendData1 = this.getTrendStats(earlyScores.sextantScores[1], brushingScores.sextantScores[1]);
        let trendData2 = this.getTrendStats(earlyScores.sextantScores[2], brushingScores.sextantScores[2]);
        let trendData3 = this.getTrendStats(earlyScores.sextantScores[3], brushingScores.sextantScores[3]);
        let trendData4 = this.getTrendStats(earlyScores.sextantScores[4], brushingScores.sextantScores[4]);
        let trendData5 = this.getTrendStats(earlyScores.sextantScores[5], brushingScores.sextantScores[5]);

        let plan0 = "", plan1 = "", plan2 = "", plan3 = "", plan4 = "", plan5 = "";
        if (this.state.hasOwnProperty('plan') && this.state.plan) {
            plan0 = this.state.plan.top_right_time + ' s';
            plan1 = this.state.plan.top_center_time + ' s';
            plan2 = this.state.plan.top_left_time + ' s';
            plan3 = this.state.plan.bottom_left_time + ' s';
            plan4 = this.state.plan.bottom_center_time + ' s';
            plan5 = this.state.plan.bottom_right_time + ' s';
        }

        // console.log(this.state.sextantScores);
        this.setState({
            sextants: {
                1: {
                    hidden: false,
                    label: this.getSextantScoreLabel(this.state.sextantScores[0]),
                    trend: trendData0.label,
                    trendColor: trendData0.color,
                    brushTime: plan0
                },
                2: {
                    hidden: false,
                    label: this.getSextantScoreLabel(this.state.sextantScores[1]),
                    trend: trendData1.label,
                    trendColor: trendData1.color,
                    brushTime: plan1
                },
                3: {
                    hidden: false,
                    label: this.getSextantScoreLabel(this.state.sextantScores[2]),
                    trend: trendData2.label,
                    trendColor: trendData2.color,
                    brushTime: plan2
                },
                4: {
                    hidden: false,
                    label: this.getSextantScoreLabel(this.state.sextantScores[3]),
                    trend: trendData3.label,
                    trendColor: trendData3.color,
                    brushTime: plan3
                },
                5: {
                    hidden: false,
                    label: this.getSextantScoreLabel(this.state.sextantScores[4]),
                    trend: trendData4.label,
                    trendColor: trendData4.color,
                    brushTime: plan4
                },
                6: {
                    hidden: false,
                    label: this.getSextantScoreLabel(this.state.sextantScores[5]),
                    trend: trendData5.label,
                    trendColor: trendData5.color,
                    brushTime: plan5
                }
            }
        });
    }

    calculateBrushScores(sessions) {
        if (!sessions || !Array.isArray(sessions) || sessions.length <= 0) {
            return;
        }

        let sextantScores = [0, 0, 0, 0, 0, 0];
        let generalScore = 0;
        let averageTime = 0;
        let averageBrushingDaily;

        let firstSessionDate = moment(sessions[0].session_date).utc();
        let lastSessionDate = moment(sessions[sessions.length - 1].session_date).utc();
        if (this.state.activePerioDate) {
            lastSessionDate = moment(this.state.activePerioDate).utc();
            if (this.state.activePerioDate === Scorecard.CURRENT_PERIO) {
                lastSessionDate = moment().utc();
            }
        }

        let days = lastSessionDate.diff(firstSessionDate, 'days');
        days = days <= 0 ? 1 : days;
        averageBrushingDaily = sessions.length / days;
        //let sessionMilestones = new Array(Math.ceil(days)).fill(0);
        let sessionsWithSextantScores = 0;
        let validSessions = 0;
        sessions.forEach(function (session, index) {
            if (session.session_duration === -1 || session.session_duration === 0) {
                // console.error("Ignoring invalid session from average calculations.")
                return;
            }
            averageTime += session.session_duration;
            generalScore += session.session_score;
            validSessions += 1;

            const scores = [
                session.session_sextant_one_score,
                session.session_sextant_two_score,
                session.session_sextant_three_score,
                session.session_sextant_four_score,
                session.session_sextant_five_score,
                session.session_sextant_six_score
            ];

            // Check if any score is not zero
            if (scores.some(score => score !== 0)) {
                // Since at least one score is not zero, add all scores to sextantScores
                sextantScores[0] += scores[0];
                sextantScores[1] += scores[1];
                sextantScores[2] += scores[2];
                sextantScores[3] += scores[3];
                sextantScores[4] += scores[4];
                sextantScores[5] += scores[5];
                sessionsWithSextantScores += 1;
            }
            //let i = Math.floor((new Date(session.session_date).getTime() - firstSessionDate.getTime()) / 86400000); // invalid array key??
            //sessionMilestones[i]++;
        });

        // console.log("sessions: ", sessions);
        // console.log("SUM sextantScores[2]: ",sextantScores[2]);
        // console.log("sessionsWithSextantScores: ",sessionsWithSextantScores);

        //let missedCounter = 0;
        //for (let m of sessionMilestones) {
        //    missedCounter = m < 2 ? missedCounter + 1 : missedCounter;
        //}

        averageTime /= validSessions;

        sextantScores = sextantScores.map(function (s) {
            return Math.round((s / sessionsWithSextantScores));
        });

        //generalScore = sextantScores.reduce((sum, a) => sum + a);
        generalScore = Math.round(generalScore / validSessions);

        return {
            generalScore: generalScore,
            sextantScores: sextantScores,
            averageBrushTime: averageTime.toFixed(2),
            averageBrushingDaily: averageBrushingDaily.toFixed(2)
        };
    }

    calculateGraphData(sessions) {
        let generalGraphData = [];
        let sextantGraphData = [[], [], [], [], [], []];


        let perioScore = null;
        let previousPerioScore = null;
        // SB-58 Confusion around the perio score interpolating between known values
        let perioStep = null;
        perioScore = this.state.perioScore.score;
        previousPerioScore = this.state.previousPerioScore.score;

        if (sessions && Array.isArray(sessions)) {
            // if (perioScore !== null && previousPerioScore !== null) {
            //     perioStep = (perioScore - previousPerioScore) / sessions.length;
            // }

            sessions.forEach(function (session, i) {
                let date = moment(session.session_date).utc();
                let month = date.format('MMM');

                let s0Score = session.session_sextant_one_score;
                let s1Score = session.session_sextant_two_score;
                let s2Score = session.session_sextant_three_score;
                let s3Score = session.session_sextant_four_score;
                let s4Score = session.session_sextant_five_score;
                let s5Score = session.session_sextant_six_score;

                generalGraphData.push({
                    date: month + '-' + date.format('DD'),
                    brush_score: Math.round(session.session_score.toFixed(1)),
                    perio_score: perioStep !== null ? Math.round(parseFloat(previousPerioScore) + (parseFloat(perioStep) * i)) : perioScore,
                    internal_date: date
                });

                sextantGraphData[0].push({
                    date: month + '-' + date.format('DD'),
                    brush_score: s0Score.toFixed(1),
                    perio_score: perioStep !== null ? Math.round(previousPerioScore + (perioStep * i)) : perioScore,
                    internal_date: date
                });

                sextantGraphData[1].push({
                    date: month + '-' + date.format('DD'),
                    brush_score: s1Score.toFixed(1),
                    perio_score: perioStep !== null ? Math.round(previousPerioScore + (perioStep * i)) : perioScore,
                    internal_date: date
                });

                sextantGraphData[2].push({
                    date: month + '-' + date.format('DD'),
                    brush_score: s2Score.toFixed(1),
                    perio_score: perioStep !== null ? Math.round(previousPerioScore + (perioStep * i)) : perioScore,
                    internal_date: date
                });

                sextantGraphData[3].push({
                    date: month + '-' + date.format('DD'),
                    brush_score: s3Score.toFixed(1),
                    perio_score: perioStep !== null ? Math.round(previousPerioScore + (perioStep * i)) : perioScore,
                    internal_date: date
                });

                sextantGraphData[4].push({
                    date: month + '-' + date.format('DD'),
                    brush_score: s4Score.toFixed(1),
                    perio_score: perioStep !== null ? Math.round(previousPerioScore + (perioStep * i)) : perioScore,
                    internal_date: date
                });

                sextantGraphData[5].push({
                    date: month + '-' + date.format('DD'),
                    brush_score: s5Score.toFixed(1),
                    perio_score: perioStep !== null ? Math.round(previousPerioScore + (perioStep * i)) : perioScore,
                    internal_date: date
                });
            });
        } else if (this.state.activePreviousPerio && this.state.activePerio) {
            // let datePrevious = this.state.activePreviousPerio.hasOwnProperty('Exam') && this.state.activePreviousPerio.Exam.hasOwnProperty('ExamDate') ? new Date(this.state.activePreviousPerio.Exam.ExamDate) : null;
            // let dateCurrent = this.state.activePerio.hasOwnProperty('Exam') && this.state.activePerio.Exam.hasOwnProperty('ExamDate') ? new Date(this.state.activePerio.Exam.ExamDate) : null;
            // let daysDifference = Math.round(Math.abs((dateCurrent - datePrevious) / (24 * 60 * 60 * 1000)));
            // daysDifference = Math.min(daysDifference, 1000);
            // if (datePrevious === null || dateCurrent === null) {
            //     return {
            //         generalGraphData: generalGraphData,
            //         sextantGraphData: sextantGraphData
            //     };
            // }
            // SB-58 do not use data interpolation between perio scores
            return {
                generalGraphData: generalGraphData,
                sextantGraphData: sextantGraphData
            }
            // if (perioScore !== null && previousPerioScore !== null) {
            //     perioStep = (perioScore - previousPerioScore) / daysDifference;
            // } else {
            //     return {
            //         generalGraphData: generalGraphData,
            //         sextantGraphData: sextantGraphData
            //     }
            // }

            // datePrevious.setDate(datePrevious.getDate() - 1);
            // for (let i = 0; i < daysDifference + 1; i++) {
            //     datePrevious.setDate(datePrevious.getDate() + 1);
            //     generalGraphData.push({
            //         date: moment(datePrevious).format('MMM - DD'),
            //         brush_score: 0,
            //         perio_score: Math.round(parseFloat(previousPerioScore) + (parseFloat(perioStep) * i)),
            //         internal_date: datePrevious
            //     });
            //
            //     sextantGraphData[0].push({
            //         date: moment(datePrevious).format('MMM - DD'),
            //         brush_score: 0,
            //         perio_score: Math.round(parseFloat(previousPerioScore) + (parseFloat(perioStep) * i)),
            //         internal_date: datePrevious
            //     });
            //
            //     sextantGraphData[1].push({
            //         date: moment(datePrevious).format('MMM - DD'),
            //         brush_score: 0,
            //         perio_score: Math.round(parseFloat(previousPerioScore) + (parseFloat(perioStep) * i)),
            //         internal_date: datePrevious
            //     });
            //
            //     sextantGraphData[2].push({
            //         date: moment(datePrevious).format('MMM - DD'),
            //         brush_score: 0,
            //         perio_score: Math.round(parseFloat(previousPerioScore) + (parseFloat(perioStep) * i)),
            //         internal_date: datePrevious
            //     });
            //
            //     sextantGraphData[3].push({
            //         date: moment(datePrevious).format('MMM - DD'),
            //         brush_score: 0,
            //         perio_score: Math.round(parseFloat(previousPerioScore) + (parseFloat(perioStep) * i)),
            //         internal_date: datePrevious
            //     });
            //
            //     sextantGraphData[4].push({
            //         date: moment(datePrevious).format('MMM - DD'),
            //         brush_score: 0,
            //         perio_score: Math.round(parseFloat(previousPerioScore) + (parseFloat(perioStep) * i)),
            //         internal_date: datePrevious
            //     });
            //
            //     sextantGraphData[5].push({
            //         date: moment(datePrevious).format('MMM - DD'),
            //         brush_score: 0,
            //         perio_score: Math.round(parseFloat(previousPerioScore) + (parseFloat(perioStep) * i)),
            //         internal_date: datePrevious
            //     });
            // }

        }

        return {
            generalGraphData: generalGraphData,
            sextantGraphData: sextantGraphData
        };
    }

    onToothClick(e) {
        if (e.number === this.state.currentTooth) {
            this.setState({
                currentTooth: null,
                currentSextant: null
            });
            return;
        }
        let sextant = Scorecard.sextants[e.number - 1];
        this.setState({
            currentTooth: e.number,
            currentSextant: sextant
        });
    }

    onPerioExamChange(e) {
        this.setState({
            activePerioDate: e.target.value,
            activePerio: null,
            teeth: null,
            currentTooth: null,
            currentSextant: null
        });
    }

    changeSextantTime(e) {
        if (!this.state.hasOwnProperty('currentSextant') || !this.state.currentSextant) {
            return;
        }

        let newTime = parseInt(e.target.value, 10);
        let newPlan = this.state.plan;
        switch (this.state.currentSextant) {
            case 1:
                newPlan.top_right_time = newTime;
                break;
            case 2:
                newPlan.top_center_time = newTime;
                break;
            case 3:
                newPlan.top_left_time = newTime;
                break;
            case 4:
                newPlan.bottom_left_time = newTime;
                break;
            case 5:
                newPlan.bottom_center_time = newTime;
                break;
            case 6:
                newPlan.bottom_right_time = newTime;
                break;
            default:
                break;
        }

        let sextants = this.state.sextants;
        sextants[this.state.currentSextant].brushTime = newTime + ' s';

        this.setState({
            plan: newPlan,
            sextants: sextants
        });
    }

    setNewPlan() {
        let identifiers = this.getPatientIdentifiers();
        if (!identifiers.id && !identifiers.pm_id && !identifiers.chart) {
            return;
        }

        fetch(`/api/v1/brushing-plan?chart_number=${encodeURIComponent(identifiers.chart)}&pm_id=${encodeURIComponent(identifiers.pm_id)}&id=${encodeURIComponent(identifiers.id)}`, {
            method: 'POST',
            headers: {
                Accept: `application/json`,
                'Content-type': `application/json`
            },
            body: JSON.stringify({
                top_left_time: this.state.plan.top_left_time,
                bottom_left_time: this.state.plan.bottom_left_time,
                top_center_time: this.state.plan.top_center_time,
                bottom_center_time: this.state.plan.bottom_center_time,
                top_right_time: this.state.plan.top_right_time,
                bottom_right_time: this.state.plan.bottom_right_time,
                overall_time: this.state.plan.top_left_time + this.state.plan.top_right_time + this.state.plan.top_center_time +
                    this.state.plan.bottom_left_time + this.state.plan.bottom_center_time + this.state.plan.bottom_right_time
            })
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                this.setState({
                    visible: true
                });
            })
            .catch((err) => {
                console.error('Could not fetch brushing plan', err);
            });
    }

    async calculatePerioScore(perio) {
        if (!perio || !perio.hasOwnProperty('Teeth') || !Array.isArray(perio.Teeth)
            || !perio.hasOwnProperty("Exam") || !perio.Exam.hasOwnProperty('ExamDate')) {
            return {
                score: -1,
                teeth: null
            };
        }

        if (this.perioScoreCache.hasOwnProperty(perio.Exam.ExamDate)) {
            return this.perioScoreCache[perio.Exam.ExamDate];
        }

        try {
            const resp = await fetch('/api/v1/perio-score', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-type': `application/json`
                },
                body: JSON.stringify(perio)
            });
            if (!resp || !resp.ok) {
                console.error("invalid response status for perio-score");
                return {
                    score: -1,
                    teeth: null
                };
            }
            let score = await resp.json();
            if (score) {
                this.perioScoreCache[perio.Exam.ExamDate] = score;
                return score;
            } else {
                console.error("bad score payload from server");
                return {
                    score: -1,
                    teeth: null
                };
            }
        } catch (err) {
            console.error('Could not get perio score', err);
            return {
                score: -1,
                teeth: null
            };
        }
    }

    onDismiss() {
        this.setState({
            visible: false
        });
    }

    updateAverageScore(e) {
        let identifiers = this.getPatientIdentifiers();
        if (!identifiers.chart && !identifiers.id && !identifiers.pm_id) {
            return;
        }

        fetch(`/api/v1/brushing-score?chart_number=${encodeURIComponent(identifiers.chart)}&pm_id=${encodeURIComponent(identifiers.pm_id)}&id=${encodeURIComponent(identifiers.id)}`, {
            method: 'GET',
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    this.setState({
                        brushScorePastLabel: "N/A",
                        brushScoreLabel: "N/A"
                    });
                }
                let body = await resp.json();

                console.log("body ", body)
                if (body.hasOwnProperty('BrushScoreLabel')) {
                    this.setState({
                        brushScoreLabel: body.BrushScoreLabel,
                    });
                } else {
                    this.setState({
                        brushScoreLabel: "N/A"
                    });
                }

                if (body.hasOwnProperty('BrushScorePastLabel')) {
                    this.setState({
                        brushScorePastLabel: body.BrushScorePastLabel,
                    });
                } else {
                    this.setState({
                        brushScorePastLabel: "N/A",
                    });
                }
            })
            .catch((err) => {
                this.setState({
                    brushScorePastLabel: "N/A",
                    brushScoreLabel: "N/A"
                })
                console.error('Could not fetch brushing overall scores', err);
            });
    }

    toggleBrushModal() {
        this.setState(prevState => ({
            brush_modal: !prevState.brush_modal
        }));
    }

    getConfigurationLink() {
        return 'https://' + auth.getDomain() + '/practice_portal/addon_configure?id=dental.ddx.smartbrush&m=configurePage';
    }

    render() {
        let focusedSextant = null;
        let perioColor = null;
        let perioScore = this.state.perioScore.score;
        let previousPerioScore = this.state.previousPerioScore.score;
        let perioTrend = this.getTrendStats(previousPerioScore, perioScore);

        if (perioScore > 0) {
            perioColor = getColourFromScore(perioScore, 100, 1);
        }

        if (this.state.currentSextant >= 1 && this.state.currentSextant <= 6) {
            let toothPerio;
            if (this.state.activePerio && Array.isArray(this.state.activePerio.Teeth)) {
                toothPerio = this.state.activePerio.Teeth.filter((t) => t.ToothNum === this.state.currentTooth)[0];
            }
            focusedSextant = <Sextant weights={this.state.weights} position={this.state.currentSextant}
                                      tooth={this.state.currentTooth} toothPerio={toothPerio}/>;
        }

        let focusedSextantInfo = null;
        let brushingPlan = null;
        if (focusedSextant) {
            focusedSextantInfo = (
                <div>
                    <div id="summary-header">
                        {focusedSextant}
                    </div>
                </div>
            );

            if (this.state.plan) {
                let planTime = 0;
                switch (this.state.currentSextant) {
                    case 1:
                        planTime = this.state.plan.top_right_time;
                        break;
                    case 2:
                        planTime = this.state.plan.top_center_time;
                        break;
                    case 3:
                        planTime = this.state.plan.top_left_time;
                        break;
                    case 4:
                        planTime = this.state.plan.bottom_left_time;
                        break;
                    case 5:
                        planTime = this.state.plan.bottom_center_time;
                        break;
                    case 6:
                        planTime = this.state.plan.bottom_right_time;
                        break;
                    default:
                        break;
                }

                brushingPlan = (
                    <div id="summary-plan">
                        <h4 className="brushing-plan-title">Brushing Plan</h4>
                        <p className="brushing-plan-sub">time (seconds)</p>
                        <Input type="number" name="brushing_time" className="plan_sextant_time" min="0"
                               onChange={this.changeSextantTime.bind(this)} value={planTime}/>
                        <Button color="info" className="brushing-plan-save mt-1" onClick={this.setNewPlan.bind(this)}>Save
                            Plan</Button>
                        <Alert color="info" className="plan-alert" isOpen={this.state.visible}
                               toggle={this.onDismiss.bind(this)}>
                            Plan updated
                        </Alert>
                    </div>
                );
            }
        }

        let averageBrushingMinutes = Math.floor(this.state.averageBrushTime / 60);
        let averageBrushingSeconds = +(this.state.averageBrushTime - (60 * averageBrushingMinutes)).toFixed(1);
        let absLabel, abmLabel;

        abmLabel = averageBrushingMinutes > 0 ? averageBrushingMinutes + ' minute' : '';
        absLabel = averageBrushingSeconds > 0 ? averageBrushingSeconds + ' second' : '';
        abmLabel = averageBrushingMinutes > 1 ? abmLabel + 's' : abmLabel;
        absLabel = averageBrushingSeconds > 1 ? absLabel + 's' : absLabel;

        let provider = this.state.activePerio && this.state.activePerio.hasOwnProperty('_Extra')
        && this.state.activePerio._Extra.hasOwnProperty('ProviderName') ? this.state.activePerio._Extra.ProviderName : '';


        let chartData = focusedSextant !== null ? this.state.sextantGraphData[this.state.currentSextant - 1] : this.state.generalGraphData;

        let chartBrush = null;
        if (chartData && Array.isArray(chartData) && chartData.length > 0) {
            chartBrush = (
                <Brush dataKey='date' height={30} stroke="#8884d8" padding={{left: 0, right: 10}} tick={true}
                       startIndex={chartData.length > 36 ? chartData.length - 36 : 0}>
                    <LineChart data={chartData}>
                        <Line type="monotone" dataKey="brush_score" stroke="#ff7300" yAxisId={0}/>
                    </LineChart>
                </Brush>
            );
        }

        let dropdown = (
            <Input type="select" name="examDate" id="exam-date-select" onChange={this.onPerioExamChange.bind(this)}>
                {
                    this.state.perioExams.map((v) => {
                        return (
                            <option key={v.date} value={v.date} selected={v.date === this.state.activePerioDate}>Perio
                                Exam: {v.date}</option>
                        )
                    })
                }
            </Input>
        );

        let chart = null;
        if (chartData !== null && chartBrush !== null) {
            chart = (
                <ResponsiveContainer width="95%" height={350}>
                    <LineChart data={chartData} margin={{top: 5, right: 20, left: 10, bottom: 10}}>
                        <XAxis dataKey="date" label={{value: "Date", offset: 0, position: 'insideBottom'}}/>
                        <YAxis yAxisId="left" label={{
                            value: "Brushing Score",
                            style: {textAnchor: 'middle'},
                            offset: -22,
                            angle: -90,
                            position: 'left'
                        }}
                               domain={[0, 100]}/>
                        <YAxis yAxisId="right" label={{
                            value: "Perio Score",
                            style: {textAnchor: 'middle'},
                            angle: -90,
                            position: 'right',
                            offset: -25,
                        }}
                               orientation="right" domain={[0, 100]}/>
                        <Tooltip/>
                        <CartesianGrid stroke="#f5f5f5" strokeDasharray="3 3"/>

                        {chartBrush}

                        <Line type="monotone" name="Brushing Score" dataKey="brush_score" stroke="#25AAE2"
                              yAxisId="left"/>
                        <Line type="monotone" name="Perio Score" dataKey="perio_score" stroke="#a25ddc"
                              yAxisId="right"/>
                        <Legend/>
                    </LineChart>
                </ResponsiveContainer>
            );
        } else {
            chart = (
                <Alert id="no-sessions-alert" color="danger">
                    {"There are no brushing sessions available for the dates " + (this.state.previousPerioDate ? "between " + this.state.previousPerioDate +
                        " and " : "before ") + (this.state.perioDate ? this.state.perioDate : "today") + "."}
                </Alert>
            )
        }

        let print_plan_info = [];
        if (this.state.plan) {
            for (let i = 0; i < 6; i++) {
                print_plan_info.push(
                    <tr className="print-plan-cell">
                        <th className="text-center">{i + 1}</th>
                        <th className="text-center">{this.state.plan[Scorecard.sextantPlans[i]]}</th>
                    </tr>
                )
            }
        }

        let today = new Date();
        let currentMonth = today.toLocaleString('en-us', {month: 'long'});
        let currentYear = today.getFullYear();
        let currentDay = String(today.getDate()).padStart(2, '0');

        let patientName = this.state.patient && this.state.patient.hasOwnProperty('first_name') ? this.state.patient.first_name : '';
        if (patientName !== "") {
            patientName += this.state.patient.hasOwnProperty('last_name') ? ' ' + this.state.patient.last_name : '';
        }

        // Do not react to sextant selection as per SB-64
        // let displayScore = 'N/A';
        // displayScore = focusedSextant && this.state.sextantScores.length === 6 ? this.state.sextantScores[this.state.currentSextant - 1] + '%' : displayScore;
        let displayScore = this.state.generalScore ? this.state.generalScore + '%' : 'N/A';

        let brushMfgLogo = null;
        switch (this.state.manufacturer) {
            case "Brushlink":
                brushMfgLogo = (
                    <img id="brush-mfg-img" alt="manufacturer logo" src={brushlinkIcon} width="63" height="64"/>
                );
                break;
            case "Sonicare":
                brushMfgLogo = (
                    <img id="brush-mfg-img" alt="manufacturer logo" src={sonicareIcon} width="128" height="64"/>
                );
                break;
        }

        return <div id="scorecard-container">
            <Container id="main-container" fluid={true}>
                <div>
                    <Row id="scorecard-header-row">
                        <Col>
                            <img onClick={this.updateAverageScore.bind(this)} alt="DDX logo" src="/ddx_scorecard.png"/>
                            <h1 id="scorecard-title">Smartbrush</h1>
                        </Col>
                        <Col xs="auto">
                            <div id="brush-mfg-logo">
                                {brushMfgLogo}
                            </div>
                            <div id="perio-selector">
                                {dropdown}
                            </div>
                            <div id="print-btn">
                                <img alt="Print report" src="print_icon_b.svg" height="64" width="64"
                                     onClick={() => {
                                         this.setState({
                                                 activePerioDate: Scorecard.CURRENT_PERIO,
                                             }, () => {
                                                 // ugly way to wait for the cascade of state changes, update react to use the useEffect hook :P
                                                 setTimeout(Scorecard.onPrintClick, 100)
                                             }
                                         );

                                     }}/>
                            </div>
                        </Col>
                    </Row>
                    <Row id="scorecard-title-row-one">
                        <Col>
                            <p id={"average-brushing-score"}>
                                {"Average Brushing Score " + this.state.brushScoreLabel}
                                <TooltipSB id="average-brushing-score-tooltip" text="Over the past 3 months."/>
                            </p>
                        </Col>
                    </Row>
                    <Row id="scorecard-title-row-two">
                        <Col id="score-bar-column">
                            <div id="scorecard-brushing-score-bar">
                                <p className="score-bar-title">
                                    Brushing Score
                                    <TooltipSB id="scorecard-brushing-score-bar-tooltip"
                                               text={(this.state.previousPerioDate ? "Between " + this.state.previousPerioDate +
                                                   " and " : "Before ") + (this.state.perioDate ? this.state.perioDate : "today") + "."}/>
                                </p>
                                <p className="score-bar-percent">
                                    {displayScore} <span
                                    className="score-bar-arrow">{this.state.generalTrend ? this.state.generalTrend.label : ''}</span>
                                </p>
                            </div>
                            <div id="scorecard-perio-score-bar">
                                <p className="score-bar-title">
                                    Perio Score
                                </p>
                                <p className="score-bar-percent">
                                    {perioScore > 0 ? perioScore + '%' : 'N/A'} <span
                                    className="score-bar-arrow">{perioTrend ? perioTrend.label : ''}</span>
                                </p>
                            </div>
                        </Col>
                    </Row>
                    <Row id="scorecard-stat-row">
                        <Col id="stat-column">
                            <div className="stat-listing">
                                Frequency: <span
                                className="stat-value">{this.state.averageBrushingDaily} times/day</span>
                            </div>
                            <div className="stat-listing">
                                Length: <span className="stat-value">{abmLabel} {absLabel}</span>
                            </div>
                            <div className="stat-listing">
                                Days Missed: <span className="stat-value">{this.state.daysMissed}</span>
                            </div>
                        </Col>
                    </Row>

                    <Row id="scorecard-info-row">
                        <Col id="toothchart-col">
                            <div id="toothchart">
                                <Toothchart
                                    onToothClick={this.onToothClick.bind(this)}
                                    teeth={this.state.teeth}
                                    sextants={this.state.sextants}
                                    notation={this.state.chart_notation}
                                />
                            </div>
                        </Col>
                        {this.state.activePerio && focusedSextant ? <Col md="3">{focusedSextantInfo}</Col> : ''}
                        <Col md={focusedSextant ? "5" : "8"}>
                            <div id="summary-graph" style={{overflowY: 'hidden', maxHeight: '400px'}}>
                                {chart}
                            </div>
                            {brushingPlan}
                        </Col>
                    </Row>
                </div>
                <Row id="scorecard-footer-row">
                    <Col>
                    </Col>
                    <Col xs="auto">
                        <img id="hs-logo" alt="Henry Schein logo" src="henryschein.png" width="167" height="27"/>
                    </Col>
                </Row>
            </Container>

            <div id="print-row-one">
                <div className="d-flex flex-row justify-content-between">
                    <span id="brushing-header-print" className="d-flex flex-column p-1 justify-content-between">
                        <h4><b>{this.state.practice_name}</b></h4>
                        <h4><b>{provider ? 'Provider: ' + provider : ''}</b></h4>
                        <h6>{currentMonth + ' ' + currentDay + ', ' + currentYear}</h6>
                    </span>
                    <span>
                        <img id="print-brush-mfg-img" alt="manufacturer logo" src={brushlinkIcon} width="64"
                             height="64"/>
                    </span>
                </div>
            </div>

            <div id="print-row-two">
                <div className="d-flex flex-column">
                    <span className="d-flex flex-column p-1">
                        <h4>Report: {patientName} </h4>
                        <span className="d-flex flex-row p-1">
                            <h4 className="print-brush-grade pr-2"><b>Brushing Grade: {this.state.generalScore ? this.state.generalScore : 'N/A'}%</b></h4>
                            <h4 className="print-perio-grade pl-5"><b>Perio Grade: {perioScore > 0 ? perioScore : 'N/A'}%</b></h4>
                        </span>
                    </span>
                    <div className="d-flex flex-row p-2 justify-content-between">
                        <span className="flex-fill">
                            <h6 className="print-brush-grade"><b>Brushing Plan</b></h6>
                            <Table className="print-plan-table" bordered>
                                <thead>
                                <tr>
                                    <th className="print-plan-header text-center">Sextant</th>
                                    <th className="print-plan-header text-center">Duration(s)</th>
                                </tr>
                                </thead>
                                {print_plan_info}
                            </Table>
                        </span>

                        <div className="d-flex flex-row pr-2 pl-3">
                            <div className="d-flex flex-column justify-content-around flex-fill">
                                <span className="print-brushing-stats p-2 my-3 ml-2 mr-1 text-center">
                                    <h4>Brushing Statistics</h4>
                                    <h5 className="pt-1 print-brush-grade">Length</h5><h5>{abmLabel} {absLabel}</h5>
                                    <h5 className="pt-3 print-brush-grade">Frequency</h5> <h5>{this.state.averageBrushingDaily} times/day</h5>
                                    <h5 className="pt-3 print-brush-grade">Days Missed</h5><h5>{this.state.daysMissed}</h5>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="print-row-three">
                <div className="d-flex flex-row pt-1">
                    <span className="patient-print-note flex-fill">
                        <h6 className="print-brush-grade p-2">Notes</h6>
                    </span>
                    <img alt="DDX logo" width="159" height="75" className="pl-2 mx-auto my-auto"
                         src="/ddx_scorecard.png"/>
                </div>
            </div>

            <Modal isOpen={false}>
                <ModalHeader toggle={this.toggleBrushModal.bind(this)}>Brush Providers</ModalHeader>
                <ModalBody>
                    <p>You have not paired with a brush provider yet, brushing data will be disabled until you link
                        up with the patient's brush provider. You can access the configuration page by clicking
                        this <a href={this.getConfigurationLink()}>link</a>.</p>
                    <br/>
                    <p>The SmartBrush configuration page can also be accessed through the DDX store and clicking the
                        configure button under the SmartBrush section.</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.toggleBrushModal.bind(this)}>OK</Button>
                </ModalFooter>
            </Modal>
        </div>;
    }
}

export default Scorecard;
